export default {
  CLICK_TO_FILL: "clickToFill",
  CAPTURE_SIGNATURE: "captureSignature",
};
